require("./bootstrap");
let $ = require("jquery");
let Vue = require("vue");
import axios from "axios";
let currency = require("currency.js");
import Cookies from "js-cookie";
import flatpickr from "flatpickr";
import DataTable from "./components/data-table";
import TopCards from "./components/top-cards";
import AffiliatePerformance from "./components/affiliate-performance";
import CardStatsAdmin from "./components/card-stats-admin";
import LineChart from "./components/charts/line-chart";
import Popper from "popper.js";

window.Cookies = Cookies;

const HTTP = axios.create(
    (axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": app.csrfToken,
        Authorization: "Bearer " + window.apiToken,
        "Content-Type": "multipart/form-data"
    })
);

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];

window.parseReportStatus = function(status) {
    switch (status) {
        case "DRAFT":
            status = '<span class="report-status draft">Draft</span>';
            break;
        case "PENDING":
            status = '<span class="report-status pending">Pending</span>';
            break;
        case "SENT":
            status = '<span class="report-status sent">Sent</span>';
            break;
        case "PAID":
            status = '<span class="report-status paid">Paid</span>';
            break;
    }

    return status;
};

window.app = new Vue({
    el: "#app",
    components: {
        DataTable,
        TopCards,
        AffiliatePerformance,
        LineChart,
        CardStatsAdmin
    },
    data: () => ({
        errors: [],
        saving: false,
        loading: false,
        searchKeyupTime: 500,
        cards: [],
        sales: [],
        monthlySales: [],
        activities: [],
        affiliates: [],
        page: 1,
        activityPage: 1,
        length: 20,
        total: 0,
        lastPage: 0,
        activityTotal: 0,
        activityLastPage: 0,
        startDate: "",
        endDate: "",
        sortUpClass: "fa-sort-up",
        sortDownClass: "fa-sort-down",
        searchQuery: "",
        tableConfig: {
            fetchUrl: "/api/salespersons",
            columns: [
                {
                    title: "Name",
                    name: "name",
                    dir: "asc",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            '<a href="/dashboard-admin/sales-persons/' +
                            value.id +
                            '">' +
                            value.name +
                            "</a>"
                        );
                    }
                },
                {
                    title: "Email",
                    name: "email",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string"
                },
                {
                    title: "Actions",
                    sortable: false,
                    width: "80px",
                    type: "actions",
                    dataAlign: "center",
                    template: value => {
                        return (
                            '<a class="btn btn-light" href="/dashboard-admin/sales-person/' +
                            value.id +
                            '"><i class="far fa-pencil"></i></a>'
                        );
                    }
                }
            ],
            extraParams: {
                start_date: { value: "" },
                end_date: { value: "" }
            },
            showTotal: false,
            orderBy: "name",
            dir: "asc"
        },
        messagesTableConfig: {
            fetchUrl: "/api/messages",
            columns: [
                {
                    title: "Name",
                    name: "name",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            '<a href="/messages/' +
                            value.id +
                            '">' +
                            value.name +
                            '</a><br><span class="company-name">' +
                            value.company_name +
                            "</span>"
                        );
                    }
                },
                {
                    title: "Subject",
                    name: "title",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            '<strong>Message</string> <span class="subject-truncated">- ' +
                            value.title +
                            "</span>"
                        );
                    }
                },
                {
                    title: "Date",
                    name: "created_at",
                    dir: "desc",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            '<strong>Message</string> <span class="subject-truncated">- ' +
                            value.title +
                            "</span>"
                        );
                    }
                },
                {
                    title: "Actions",
                    sortable: false,
                    width: "80px",
                    type: "actions",
                    dataAlign: "center",
                    template: value => {
                        return (
                            '<a class="btn btn-light" href="/messages/' +
                            value.id +
                            '"><i class="far fa-pencil"></i></a>'
                        );
                    }
                }
            ],
            extraParams: {
                start_date: { value: "" },
                end_date: { value: "" }
            },
            showTotal: false,
            orderBy: "created_at",
            dir: "desc"
        },
        salesReportsTableConfig: {
            fetchUrl: "/api/salesreports",
            columns: [
                {
                    title: "Customer",
                    name: "name",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            value.name +
                            '<br><span class="company-name">' +
                            value.company_name +
                            "</span>"
                        );
                    }
                },
                {
                    title: "Description",
                    name: "report_month",
                    dir: "desc",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        const months = [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ];
                        let fDate =
                            months[value.r_month - 1] + " " + value.r_year;

                        //let path = roleId === 3? '' : '/dashbaord-admin';
                        let path = "";

                        return (
                            '<a href="' +
                            path +
                            "/sales-reports/" +
                            value.id +
                            '">' +
                            fDate +
                            " Sales Report</a>"
                        );
                    }
                },
                {
                    title: "Total",
                    name: "total",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "total",
                    template: value => {
                        return currency(value.total).format();
                    }
                },
                {
                    title: "Status",
                    name: "status",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return (
                            "<strong>" +
                            window.parseReportStatus(value.status) +
                            "</strong>"
                        );
                    }
                },
                {
                    title: "Actions",
                    sortable: false,
                    width: "220",
                    type: "actions",
                    dataAlign: "center",
                    template: value => {
                        let html =
                            '<a class="btn btn-light" href="/sales-reports/' +
                            value.id +
                            '"><i class="far fa-eye"></i></a>';

                        if (window.roleId === 1) {
                            html +=
                                ' &nbsp; <div class="dropdown"><a class="btn btn-light dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href=""><i class="far fa-print"></i></a><div class="dropdown-menu dropdown-menu-right"><a class="dropdown-item" href="/sales-reports/' +
                                value.id +
                                '/print">Print MileValue Commissions</a><a class="dropdown-item" href="/sales-reports/' +
                                value.id +
                                '/print?for_affiliate=1">Print Affiliate Commissions</a></div></div>';

                            html +=
                                '<form style="display: inline-block" action="/dashboard-admin/sales-reports/' +
                                value.id +
                                '" method="post"><input type="hidden" name="_token" value="' +
                                window.csrfToken +
                                '"><input type="hidden" name="_method" value="delete"><button type="submit" class="btn btn-light confirm-delete""><i class="far fa-times" style="color: red"></i></button></form>';
                        }

                        if (window.roleId === 3) {
                            html +=
                                '<a class="btn btn-light" role="button" href="/sales-reports/' +
                                value.id +
                                '/print"><i class="far fa-print"></i></a>';
                        }

                        return html;
                    }
                }
            ],
            extraParams: {
                start_date: { value: "" },
                end_date: { value: "" }
            },
            showTotal: true,
            orderBy: "report_month",
            dir: "desc"
        },
        performanceTableConfig: {
            fetchUrl: "/api/salesperformance",
            columns: [
                {
                    title: "Sub-Affiliate",
                    name: "company_name",
                    dir: "asc",
                    sortable: true,
                    width: "",
                    type: "string"
                },
                {
                    title: "Card Sales",
                    name: "card_sales",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return value.card_sales;
                    }
                },
                {
                    title: "Revenue Share",
                    name: "affiliate_revenue_share",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "total",
                    template: value => {
                        return (
                            value.affiliate_revenue_share +
                            " / " +
                            value.mv_revenue_share
                        );
                    }
                },
                {
                    title: "Gross Commissions",
                    name: "gross_commission",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return currency(value.gross_commission).format();
                    }
                },
                {
                    title: "Sub-Affiliate Commissions",
                    name: "affiliate_commissionn",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return currency(value.affiliate_commission).format();
                    }
                },
                {
                    title: "MileValue Commission",
                    name: "mv_commission",
                    dir: "",
                    sortable: true,
                    width: "",
                    type: "string",
                    template: value => {
                        return currency(value.mv_commission).format();
                    }
                }
            ],
            extraParams: {
                start_date: { value: "" },
                end_date: { value: "" }
            },
            showTotal: false,
            orderBy: "company_name",
            dir: "asc"
        },
        cardsTableSettings: {
            orderBy: "short_desc",
            sortDir: "asc",
            columns: {
                short_desc: { name: "Card Name", dir: "asc" },
                commission: { name: "Commssion", dir: "asc" },
                status: { name: "Status", dir: "asc" }
            }
        },
        salesTableSettings: {
            orderBy: "sale_process_date",
            sortDir: "desc",
            columns: {
                click_date: { name: "Click Date", dir: "asc" },
                sale_process_date: { name: "Sale Date", dir: "desc" },
                customer_id: { name: "Sub-Affiliate", dir: "asc" },
                sale_commission: { name: "Commssion", dir: "asc" },
                referral_card_title: { name: "Product Name", dir: "asc" }
            }
        },
        monthlySalesTableSettings: {
            orderBy: "report_month",
            sortDir: "desc",
            columns: {
                sale_process_date: { name: "Date", dir: "desc" },
                report_month: { name: "Description", dir: "asc" },
                status: { name: "Status", dir: "asc" },
                total: { name: "Total", dir: "asc" }
            }
        },
        affiliatesTableSettings: {
            orderBy: "customer_id",
            sortDir: "asc",
            columns: {
                name: { name: "name", dir: "asc" },
                email: { name: "email", dir: "asc" },
                customer_id: { name: "customer_id", dir: "asc" },
                total: { name: "Total", dir: "asc" }
            }
        },
        tabName: "",
        lifeTimeRevenue: 0,
        lifeTimeCommission: 0,
        lifeTimeMvCommission: 0,
        lifeTimeCardSales: 0,
        referralCount: 0,
        clickCount: 0,
        customerId: "",
        reportMonth: 0,
        reportYear: 0,
        cardSales: 0,
        creditCardClicks: 0,
        earningsPerClick: 0,
        clickThruRate: 0,
        statsRevenue: 0,
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        toastMessage: "",
        reportSending: false,
        tableTotal: 0.0,
        salesReportChartLoaded: false,
        salesReportChartData: null,
        trafficReportChartLoaded: false,
        trafficReportChartData: null,
        trafficReportChartOptions: {},
        salesReportChartOptions: {}
    }),
    filters: {
        formatMoney(value) {
            if (!value) return "";
            return currency(value).format();
        },
        formatThousand(value) {
            if (!value) return "";
            return value.toLocaleString();
        },
        formatReportDesc(value) {
            let fDate = months[value.r_month - 1] + " " + value.r_year;
            return fDate;
        }
    },
    computed: {
        years() {
            let year = new Date().getFullYear();
            let oldYear = year - 3;
            return Array.from(
                { length: year - oldYear },
                (value, index) => year--
            );
        }
    },
    methods: {
        getCards() {
            this.showLoading();
            HTTP.get(
                "/api/cards?page=" +
                    this.page +
                    "&order_by=" +
                    this.cardsTableSettings.orderBy +
                    "&sort_dir=" +
                    this.cardsTableSettings.sortDir +
                    "&length=" +
                    this.length +
                    "&search_query=" +
                    this.searchQuery
            )
                .then(response => {
                    this.cards = response.data.cards.data;
                    this.total = response.data.cards.total;
                    this.lastPage = response.data.cards.last_page;
                    this.hideLoading();
                })
                .catch(e => {
                    //console.log('sort error');
                });
        },
        runApiImport() {
            this.toastMessage = "Running API Import ...";
            $("#toast").toast({ autohide: false });
            $("#toast").toast("show");

            HTTP.get("/api/run-api-import")
                .then(response => {
                    this.toastMessage = "API Import Finised";
                    setTimeout(() => {
                        $("#toast").toast("hide");
                    }, 2000);
                })
                .catch(e => {
                    this.toastMessage = "API Import Failed";
                });
        },
        changeCardsTablePage(index) {
            this.page = index;
            this.getCards();
        },
        changeCardsLength() {
            this.page = 1;
            this.getCards();
        },
        searchCards() {
            this.getCards();
        },
        sortCardsColumns(column) {
            this.cardsTableSettings.orderBy = column;

            let keys = Object.keys(this.cardsTableSettings.columns);
            for (const key of keys) {
                if (key === column) {
                    if (this.cardsTableSettings.columns[key].dir === "asc") {
                        this.cardsTableSettings.columns[key].dir = "desc";
                        this.cardsTableSettings.sortDir = "desc";
                    } else {
                        this.cardsTableSettings.columns[key].dir = "asc";
                        this.cardsTableSettings.sortDir = "asc";
                    }
                } else {
                    this.cardsTableSettings.columns[key].dir = "asc";
                }
            }

            setTimeout(() => {
                this.getCards();
            }, 100);
        },

        getSales() {
            this.tableTotal = 0.0;
            this.showLoading();
            let url =
                "/api/sales?page=" +
                this.page +
                "&order_by=" +
                this.salesTableSettings.orderBy +
                "&sort_dir=" +
                this.salesTableSettings.sortDir +
                "&length=" +
                this.length +
                "&search_query=" +
                this.searchQuery +
                "&start_date=" +
                this.startDate +
                "&end_date=" +
                this.endDate;

            HTTP.get(url)
                .then(response => {
                    this.sales = response.data.sales.data;
                    this.total = response.data.sales.total;
                    this.lastPage = response.data.sales.last_page;
                    this.referralCount = response.data.referrals_count;
                    this.earningsPerClick = parseFloat(
                        response.data.earnings_per_click
                    );
                    this.creditCardClicks = response.data.credit_card_clicks;
                    this.statsRevenue = response.data.revenue;
                    this.clickThruRate = parseFloat(
                        response.data.click_thru_rate
                    );
                    this.hideLoading();

                    this.sales.forEach(v => {
                        this.tableTotal += parseFloat(v.sale_commission);
                    });
                })
                .catch(e => {
                    console.log(e);
                    this.hideLoading();
                });
        },
        changeSalesTablePage(index) {
            this.page = index;
            this.getSales();
        },
        changeSalesLength() {
            this.page = 1;
            this.getSales();
        },
        searchSales() {
            this.getSales();
        },
        sortSalesColumns(column) {
            this.salesTableSettings.orderBy = column;

            let keys = Object.keys(this.salesTableSettings.columns);
            for (const key of keys) {
                if (key === column) {
                    if (this.salesTableSettings.columns[key].dir === "asc") {
                        this.salesTableSettings.columns[key].dir = "desc";
                        this.salesTableSettings.sortDir = "desc";
                    } else {
                        this.salesTableSettings.columns[key].dir = "asc";
                        this.salesTableSettings.sortDir = "asc";
                    }
                } else {
                    this.salesTableSettings.columns[key].dir = "asc";
                }
            }

            setTimeout(() => {
                this.getSales();
            }, 100);
        },
        updateSalesList() {
            if (this.startDate && this.endDate) {
                this.getSales();
                if (this.$refs.hasOwnProperty("cardStatsAdmin")) {
                    this.$refs.cardStatsAdmin.getData();
                }
            }
        },
        getMonthly() {
            this.showLoading();
            let url =
                "/api/sub-affiliates/" +
                window.userId +
                "/monthly-sales?page=" +
                this.page +
                "&order_by=" +
                this.monthlySalesTableSettings.orderBy +
                "&sort_dir=" +
                this.monthlySalesTableSettings.sortDir +
                "&length=" +
                this.length +
                "&search_query=" +
                this.searchQuery +
                "&start_date=" +
                this.startDate +
                "&end_date=" +
                this.endDate;

            HTTP.get(url)
                .then(response => {
                    this.monthlySales = response.data.monthly_sales.data;
                    this.total = response.data.monthly_sales.total;
                    this.lastPage = response.data.monthly_sales.last_page;
                    this.lifeTimeRevenue = response.data.lifetime_revenue;
                    this.lifeTimeCommission = response.data.lifetime_commission;
                    this.lifeTimeMvCommission =
                        response.data.lifetime_mv_commission;
                    this.lifeTimeCardSales = response.data.lifetime_card_sales;
                    this.referralCount = response.data.referral_count;
                    this.clickCount = response.data.click_count;
                    this.hideLoading();
                })
                .catch(e => {
                    console.log(e);
                    this.hideLoading();
                });
        },
        changeMonthlyTablePage(index) {
            this.page = index;
            this.getMonthly();
        },
        changeMonthlyLength() {
            this.page = 1;
            this.getMonthly();
        },
        searchMonthly() {
            this.getMonthly();
        },
        sortMonthlyColumns(column) {
            this.monthlySalesTableSettings.orderBy = column;

            let keys = Object.keys(this.monthlySalesTableSettings.columns);
            for (const key of keys) {
                if (key === column) {
                    if (
                        this.monthlySalesTableSettings.columns[key].dir ===
                        "asc"
                    ) {
                        this.monthlySalesTableSettings.columns[key].dir =
                            "desc";
                        this.monthlySalesTableSettings.sortDir = "desc";
                    } else {
                        this.monthlySalesTableSettings.columns[key].dir = "asc";
                        this.monthlySalesTableSettings.sortDir = "asc";
                    }
                } else {
                    this.monthlySalesTableSettings.columns[key].dir = "asc";
                }
            }

            setTimeout(() => {
                this.getMonthly();
            }, 100);
        },
        updateMonthlyList() {
            if (this.startDate && this.endDate) {
                this.getMonthly();
            }
        },
        showPageAmount() {
            let start = this.page * this.length - this.length;
            let count = this.page * this.length;
            if (count > this.total) {
                count = this.total;
            }
            if (start === 0) {
                start = 1;
            }
            return start + " - " + count;
        },
        getActivity() {
            this.showLoading();
            let url =
                "/api/sub-affiliates/" +
                window.userId +
                "/activity?page=" +
                this.activityPage;

            HTTP.get(url)
                .then(response => {
                    this.activities = response.data;
                    //this.activityTotal = response.data.total;
                    //this.activityLastPage = response.data.last_page;
                    this.hideLoading();
                })
                .catch(e => {
                    //console.log('sort error');
                });
        },
        getAffiliates() {
            this.showLoading();
            HTTP.get(
                "/api/affiliates?page=" +
                    this.page +
                    "&order_by=" +
                    this.affiliatesTableSettings.orderBy +
                    "&sort_dir=" +
                    this.affiliatesTableSettings.sortDir +
                    "&length=" +
                    this.length +
                    "&search_query=" +
                    this.searchQuery
            )
                .then(response => {
                    this.affiliates = response.data.affiliates.data;
                    this.total = response.data.affiliates.total;
                    this.lastPage = response.data.affiliates.last_page;
                    this.hideLoading();
                })
                .catch(e => {
                    //console.log('sort error');
                });
        },
        changeAffiliatesTablePage(index) {
            this.page = index;
            this.getAffiliates();
        },
        changeAffiliatesLength() {
            this.page = 1;
            this.getAffiliates();
        },
        sortAffiliatesColumns(column) {
            this.affiliatesTableSettings.orderBy = column;

            let keys = Object.keys(this.affiliatesTableSettings.columns);
            for (const key of keys) {
                if (key === column) {
                    if (
                        this.affiliatesTableSettings.columns[key].dir === "asc"
                    ) {
                        this.affiliatesTableSettings.columns[key].dir = "desc";
                        this.affiliatesTableSettings.sortDir = "desc";
                    } else {
                        this.affiliatesTableSettings.columns[key].dir = "asc";
                        this.affiliatesTableSettings.sortDir = "asc";
                    }
                } else {
                    this.affiliatesTableSettings.columns[key].dir = "asc";
                }
            }

            setTimeout(() => {
                this.getAffiliates();
            }, 100);
        },
        searchAffiliates() {
            this.getAffiliates();
        },
        updateDataTable() {
            this.$refs.dataTable.searchQuery = this.searchQuery;
            this.$refs.dataTable.update();
        },
        generateReports() {
            if (this.reportMonth && this.reportYear) {
                this.showLoading();
                HTTP.get(
                    "/api/generate-reports?month=" +
                        this.reportMonth +
                        "&year=" +
                        this.reportYear +
                        "&customer_id=" +
                        this.customerId
                )
                    .then(response => {
                        this.hideLoading();
                        this.$refs.dataTable.page = 1;
                        this.$refs.dataTable.update();

                        $("#reports-modal").modal("hide");

                        this.showToast("Reports generation complete.");
                    })
                    .catch(e => {
                        this.hideLoading();
                    });
            }
        },
        sendReport(e) {
            this.reportSending = true;
            const reportId = e.target.getAttribute("data-report-id");

            HTTP.get("/dashboard-admin/sales-reports/" + reportId + "/send")
                .then(response => {
                    this.reportSending = false;
                    this.showToast("Report sent.");
                })
                .catch(e => {
                    this.reportSending = false;
                });
        },
        parseReportStatus(status) {
            switch (status) {
                case "DRAFT":
                    status = '<span class="report-status draft">Draft</span>';
                    break;
                case "PENDING":
                    status =
                        '<span class="report-status pending">Pending</span>';
                    break;
                case "SENT":
                    status = '<span class="report-status sent">Sent</span>';
                    break;
                case "PAID":
                    status = '<span class="report-status paid">Paid</span>';
                    break;
            }

            return status;
        },
        getSalesReportChart() {
            this.salesReportChartLoaded = false;

            this.salesReportChartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 12,
                        bottom: 0
                    }
                },
                title: {
                    display: false,
                    text: "Sales Report",
                    fontSize: 20,
                    fontColor: "#222"
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return currency(tooltipItem.yLabel).format();
                        }
                    }
                },
                legend: {
                    display: true,
                    align: "end",
                    labels: {
                        fontColor: "#222"
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                borderDash: [3, 2]
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    return value.toLocaleString("en-US", {
                                        style: "currency",
                                        currency: "USD"
                                    });
                                }
                            }
                        }
                    ]
                }
            };

            HTTP.get(
                "/api/salesreportchart?start_date=" +
                    this.startDate +
                    "&end_date=" +
                    this.endDate
            )
                .then(response => {
                    this.salesReportChartLoaded = true;

                    const labels = response.data.labels;
                    const grossSales = response.data.gross_sales;
                    const affiliateSales = response.data.affiliate_sales;
                    const mvSales = response.data.mv_sales;

                    this.salesReportChartData = {
                        labels: labels,
                        datasets: response.data.data_set
                    };
                })
                .catch(e => {
                    console.log("Sales report chart error ", e);
                    this.salesReportChartLoaded = true;
                });
        },
        getTrafficReportChart() {
            this.trafficReportChartLoaded = false;

            this.trafficReportChartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 12,
                        bottom: 0
                    }
                },
                title: {
                    display: false,
                    text: "Traffic Report",
                    fontSize: 20,
                    fontColor: "#222"
                },
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return tooltipItem.yLabel;
                            //return currency(tooltipItem.yLabel).format();
                        }
                    }
                },
                legend: {
                    display: true,
                    align: "end",
                    labels: {
                        fontColor: "#222"
                    }
                },
                scales: {
                    xAxes: [
                        {
                            gridLines: {
                                display: false
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                borderDash: [3, 2]
                            },
                            ticks: {
                                callback: function(value, index, values) {
                                    return value;
                                    //return value.toLocaleString("en-US",{style:"currency", currency:"USD"});
                                }
                            }
                        }
                    ]
                }
            };

            HTTP.get(
                "/api/trafficreportchart?start_date=" +
                    this.startDate +
                    "&end_date=" +
                    this.endDate
            )
                .then(response => {
                    this.trafficReportChartLoaded = true;

                    const labels = response.data.labels;
                    const grossSales = response.data.gross_sales;
                    const affiliateSales = response.data.affiliate_sales;
                    const mvSales = response.data.mv_sales;

                    this.trafficReportChartData = {
                        labels: labels,
                        datasets: response.data.data_set
                    };
                })
                .catch(e => {
                    console.log("Sales report chart error ", e);
                    this.salesReportChartLoaded = true;
                });
        },
        updatedDashboardComponents() {
            this.$refs.topSellingCards.fromDashboard = true;
            this.$refs.topSellingCards.getData();
            if (this.$refs.hasOwnProperty("affiliatePerformance")) {
                this.$refs.affiliatePerformance.getData();
            }
            if (this.$refs.hasOwnProperty("salesReportChart")) {
                this.getSalesReportChart();
            }
            if (this.$refs.hasOwnProperty("trafficReportChart")) {
                this.getTrafficReportChart();
            }
            if (this.$refs.hasOwnProperty("cardStatsAdmin")) {
                this.$refs.cardStatsAdmin.getData();
            }
        },
        updateCardsList() {
            this.$refs.topSellingCards.getData();
        },
        showToast(message) {
            this.toastMessage = message;
            $("#toast").toast("show");
            setTimeout(() => {
                this.toastMesage = "";
            }, 2200);
        },
        showLoading() {
            setTimeout(() => {
                this.loading = true;
            });
        },
        hideLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 1100);
        },
        isTouchDevice() {
            return (
                "ontouchstart" in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            );
        }
    },
    created() {
        this.updateDataTable = window._.debounce(
            this.updateDataTable,
            this.searchKeyupTime
        );
        this.searchCards = window._.debounce(
            this.searchCards,
            this.searchKeyupTime
        );
        this.searchSales = window._.debounce(
            this.searchSales,
            this.searchKeyupTime
        );
        this.searchAffiliates = window._.debounce(
            this.searchAffiliates,
            this.searchKeyupTime
        );
        let date = new Date();

        let sDate = new Date(date.getFullYear(), date.getMonth(), 1)
            .toISOString()
            .slice(0, 10);
        let eDate = new Date().toISOString().slice(0, 10);

        if (Cookies.get("sdate")) {
            sDate = Cookies.get("sdate");
        }

        if (Cookies.get("edate")) {
            eDate = Cookies.get("edate");
        }

        this.startDate = sDate;
        this.endDate = eDate;

        this.performanceTableConfig.extraParams.start_date.value = sDate;
        this.performanceTableConfig.extraParams.end_date.value = eDate;
    },
    mounted() {
        let self = this;
        const datePicker = flatpickr(".date-picker", {
            dateFormat: "Y-m-d",
            onChange: function(selectedDates, dateStr, instance) {
                const updateMethod = instance.element.getAttribute(
                    "data-callback"
                );
                if (updateMethod && updateMethod.length) {
                    setTimeout(() => {
                        if (instance.element.name === "start_date") {
                            Cookies.set("sdate", dateStr, { expires: 7 });
                        }
                        if (instance.element.name === "end_date") {
                            Cookies.set("edate", dateStr, { expires: 7 });
                        }

                        self[updateMethod]();
                    }, 100);
                }
            }
        });

        let $cardsTable = document.querySelector("#cards-table");
        let $salesTable = document.querySelector("#sales-table");
        let $affiliatesTable = document.querySelector("#affiliates-table");
        let $monthlySalesTable = document.querySelector("#monthly-sales-table");
        let $activityList = document.querySelector("#activity-list");

        if ($cardsTable) {
            this.getCards();
        }

        if ($salesTable) {
            this.getSales();
        }

        if ($affiliatesTable) {
            this.getAffiliates();
        }

        if ($monthlySalesTable) {
            this.getMonthly();
        }

        if ($activityList) {
            this.getActivity();
        }

        $('[data-toggle="tooltip"]').tooltip();

        if (this.isTouchDevice()) {
            let $menu = document.getElementById("navbarSupportedContent");
            $menu.classList.remove("show");
        }

        let $dashboardNavItems = document.querySelectorAll(
            ".dashboard-nav .has-dropdown"
        );
        if ($dashboardNavItems.length) {
            $dashboardNavItems.forEach(el => {
                if (this.isTouchDevice()) {
                    el.addEventListener("touchstart", e => {
                        let $parent = e.target;
                        if ($parent.className === "a-link") {
                            $parent = $parent.parentElement;
                        }
                        if ($parent.classList.contains("has-dropdown")) {
                            if ($parent.classList.contains("open")) {
                                $parent.classList.remove("open");
                            } else {
                                $parent.classList.add("open");
                            }
                        }
                    });
                } else {
                    el.addEventListener("click", e => {
                        console.log(e);
                        let $parent = e.target;
                        if ($parent.className === "a-link") {
                            $parent = $parent.parentElement;
                        }
                        if ($parent.classList.contains("has-dropdown")) {
                            if ($parent.classList.contains("open")) {
                                $parent.classList.remove("open");
                            } else {
                                $parent.classList.add("open");
                            }
                        }
                    });
                }
            });
        }

        const $exportPerformanceBtn = document.querySelector(
            ".export-performance-btn"
        );

        if ($exportPerformanceBtn) {
            $exportPerformanceBtn.addEventListener("click", el => {
                el.preventDefault();
                let $form = document.getElementById("performance-export-form");

                const startDate = this.performanceTableConfig.extraParams
                    .start_date.value;
                const endDate = this.performanceTableConfig.extraParams.end_date
                    .value;

                let $inputStart = document.createElement("input");
                let $inputEnd = document.createElement("input");

                $inputStart.value = startDate;
                $inputStart.name = "start_date";
                $inputStart.type = "hidden";

                $inputEnd.value = endDate;
                $inputEnd.name = "end_date";
                $inputEnd.type = "hidden";

                $form.appendChild($inputStart);
                $form.appendChild($inputEnd);

                $form.submit();
            });
        }

        const $hasSalesReportChart = document.querySelector(
            ".has-sales-report-chart"
        );
        if ($hasSalesReportChart) {
            this.getSalesReportChart();
        }
        const $hasTrafficReportChart = document.querySelector(
            ".has-traffic-report-chart"
        );
        if ($hasTrafficReportChart) {
            this.getTrafficReportChart();
        }
    }
});
